import { useState } from "react";

export function useBottomSheet(initialState = false) {
  const [showSheet, setShowSheet] = useState(initialState);
  const [isAnimating, setIsAnimating] = useState(false);

  const toggleSheet = () => {
    if (showSheet) {
      setIsAnimating(false);
      setTimeout(() => {
        setShowSheet(false);
      }, 300);
    } else {
      setShowSheet(true);
      setTimeout(() => {
        setIsAnimating(true);
      }, 10);
    }
  };

  const openSheet = () => {
    if (!showSheet) {
      setShowSheet(true);
      setTimeout(() => {
        setIsAnimating(true);
      }, 10);
    }
  };

  const closeSheet = () => {
    if (showSheet) {
      setIsAnimating(false);
      setTimeout(() => {
        setShowSheet(false);
      }, 300);
    }
  };

  return {
    showSheet,
    isAnimating,
    toggleSheet,
    openSheet,
    closeSheet,
    setIsAnimating,
  };
}
